import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import EliminaHorario from './EliminaHorario';
import EditaHorario from './EditaHorario';
import { ContextAdminHoraProvider } from './ContextAdminHorario';
import { useAdminHorario } from './hooks/useAdminHorario';
import NuevoHorario from './NuevoHorario';

const AdminHorario = () => {
    
    const { ocultaDialogElimina, accionButtonBody, ocultaDialogEdita, ocultaDialogNuevo, onNuevo, mostrarEdita, mostrarNuevo, 
        horario, lstHorario, cargaHorario, mostrarElimina, filtros, textoFilterTemplate } = useAdminHorario();

    return (
        <ContextAdminHoraProvider>
        <div className="card">
            <Dialog visible={mostrarElimina} onHide={ocultaDialogElimina} style={{ width: '40vw' }} modal draggable={false} closeOnEscape={false} >
                <EliminaHorario datosHorario={horario} ocultaDialogElimina={ocultaDialogElimina} />
            </Dialog>
            <Dialog visible={mostrarEdita} onHide={ocultaDialogEdita} style={{ width: '40vw' }} modal draggable={false} closeOnEscape={false}>
                <EditaHorario datosHorario={horario} ocultaDialogEdita={ocultaDialogEdita}></EditaHorario>
            </Dialog>
            <Dialog header='Nuevo Horario' visible={mostrarNuevo} onHide={ocultaDialogNuevo} style={{ width: '40vw' }} modal draggable={false} closeOnEscape={false}>
                <NuevoHorario ocultaDialogNuevo={ocultaDialogNuevo} />
            </Dialog>
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-10">
                    <h5>Administrador de Horarios</h5>
                </div>
                <div className="field col-12 md:col-2">
                    <Button label="Nuevo Horario" onClick={onNuevo} />
                </div>
                <div className="field col-12 md:col-12">
                    <DataTable value={lstHorario} paginator rows={5} rowsPerPageOptions={[5, 10, 20]} stripedRows tableStyle={{ width: '100%' }} filters={filtros} filterDisplay="row" emptyMessage="No se encontraron resultados." loading={cargaHorario}>
                        <Column header="Sigla Horario" 
                        field="sigla" 
                        filter 
                        filterPlaceholder="Buscar por Sigla" 
                        filterElement={(options) => textoFilterTemplate(options, 'sigla')} 
                        showFilterMenu={false} 
                        style={{ width: '20%' }} />
                        <Column header="Descripcion Horario" field="nombre" 
                        filter 
                        filterPlaceholder="Buscar por Nombre" 
                        filterElement={(options) => textoFilterTemplate(options, 'nombre')} 
                        showFilterMenu={false} 
                        style={{ width: '60%' }} />
                        <Column header="Acciones" style={{ width: '20%' }} body={accionButtonBody} />
                    </DataTable>
                </div>
            </div>
        </div>
        </ContextAdminHoraProvider>
    );
};

export default AdminHorario;
